<template lang="pug">
.commerce-container(ref="card")
  ods-module.commerce-container__module(style='margin-bottom: 8px;')
    h2.commerce-container__title.tp-m-micro(@click="gotoCommerceDetail") {{ data.descomercio }}
    ods-icon.icon-button(
      name='chevron-right'
      size='18'
      color="#6E767D"
      @click.native="setActive"
      )
  ods-module.commerce-container__info
    .text.item
      p.title Código interno del Comercio
      p.info-comercio {{ data.codcom }}
    .text.item
      p.title Estado
      p.info-comercio {{ data.fecbaja.anno === 0 ? 'Activo' : 'No activo' }}
    .text.item
      p.title Producto
      p.info-comercio {{ data.desprod }}
    .text.item
      p.title Tipo de tarifario
      p.info-comercio {{ data.descon }}

</template>

<script>

export default {
  props: {
    data: {
      type: Object
    }
  },
  data () {
    return {
      displayInfo: false
    }
  },
  methods: {
    gotoCommerceDetail () {
      this.$router.push({ name: 'Commerce', params: { id: this.data.registro_Numero, comercio: this.data } })
    },

    setActive () {
      this.$refs.card.className.match(/\bactive\b/) === null
        ? this.$emit('active', this.data.registro_Numero)
        : this.$emit('active', '')
    }
  }
}
</script>

<style lang='scss' scoped>
.commerce-container {
  margin: rem(16) rem(24) rem(16) 0;

  &__title:hover {
    cursor: pointer;
    text-decoration: underline;
    font-weight: 500;
  }

  &.active {
    .icon-button {
      transform: rotate(90deg);
    }

    .commerce-container__info {
      height: rem(300);
    }
  }

  .icon-button {
    cursor: pointer;
    transform: rotate(0deg);
    transition: all .5s;
  }

  /deep/ .ods-module {
    width: rem(224);
  }

  &__module {
    position: relative;
    z-index: 3;

    /deep/ .ods-module__body {
      padding: rem(24) rem(12);
      display: flex;
      justify-content: space-between;
    }
  }

  &__info {
    top: -24px;
    position: relative;
    z-index: 1;
    transition: .4s all;
    height: 0;

    /deep/ .ods-module__body {
      padding: rem(24) rem(12);

      .title {
        font-weight: 500;
        font-size: 9px;
        line-height: 16px;
        text-transform: uppercase;
        color: #6E767D;
        cursor: pointer;
      }

      .info-comercio {
        margin-bottom: rem(24);
      }
    }
  }
}
</style>
